import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';
import { LinkWrapper } from 'app/common/components/singlespa/link-wrapper';

import { AtlassianAccountOnboardingLinks } from '../AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';
const format = forNamespace(['aa onboarding', 'banner'], {
  shouldEscapeStrings: false,
});

export enum WarningType {
  deletion = 'delete msg',
  deactivate = 'deactivation msg',
}

interface AccountWarningProps {
  aaEmail: string;
  orgName: string;
  warningDate: string;
  warningMsg: string;
  urgent: boolean;
  onDismiss: () => void;
  onClickRemove: () => void;
}

export const AccountWarning: FunctionComponent<AccountWarningProps> = ({
  aaEmail,
  orgName,
  warningDate,
  warningMsg,
  onDismiss,
  onClickRemove,
  urgent,
}) => {
  return (
    <OnboardingDialog
      title={format(
        warningMsg === WarningType.deactivate
          ? 'deactivated title'
          : 'deleted title',
        { date: warningDate },
      )}
      helpLink={AtlassianAccountOnboardingLinks.Help}
      closeDialog={onDismiss}
      className={styles.accountWarningBody}
    >
      <div className={styles.accountWarningContent}>
        {urgent ? (
          <div>
            <p>
              {format(
                warningMsg === WarningType.deactivate
                  ? 'deactivated urgent'
                  : 'deleted urgent',
                { aaEmail, date: warningDate },
              )}
            </p>
            <p>
              {format('keep using account', {
                date: warningDate,
                aaEmail: aaEmail,
              })}
            </p>
          </div>
        ) : (
          <p>
            {format(warningMsg, {
              org: orgName,
            })}{' '}
            {format('keep using account', {
              date: warningDate,
              aaEmail: aaEmail,
            })}
          </p>
        )}
      </div>
      <div className={styles.section}>
        <LinkWrapper href="/me" role="link">
          <PrimaryButton onClick={onClickRemove}>
            {format('remove org domain email', { orgDomain: orgName })}
          </PrimaryButton>
        </LinkWrapper>
      </div>
    </OnboardingDialog>
  );
};
